import {CubeDimension, CubeMeasure, DimHierarchyData, DimHierarchyLevelData, MeasureData} from './service';
import {Component, EventEmitter, Input, Output} from "@angular/core";
import {MDMService} from '../services/mdmService.service';


@Component({
    selector: 'dataMapper',
    templateUrl: 'dataMapper.html'
})

export class DataMapper {

    @Input() analyticalModelData: any = {};
    @Input() isStarSchema: boolean;
    @Input() dimensionList: any = [];

    public cubeMesMap = new Map();
    public cubeDimMap = new Map();
    public isDimMap = new Map();
    public dimMap = new Map();
    public cubeDimension: any;
    public dimValidation: boolean;
    public rffIndexMap = new Map();
    public selectDimMap = new Map();
    public PkExistsMap = new Map();
    public defaultTimeFilter: number;
    public isDimTime: boolean = false;
    public dimTimeMap = new Map();



    // public measureHistory = new Map();
    // public dimensionHistory = new Map();
    @Output() dimValidationSender = new EventEmitter();
    @Output() measureListSender = new EventEmitter();
    @Output() dimensionListSender = new EventEmitter();
    @Output() formulaMeasureEmitter = new EventEmitter();
    public formualMeasureMap = new Map();

    constructor(public cubeService: MDMService) {

    }

    ngOnChanges() {
        this.separateDimensionAndMeasure();
        if (this.isStarSchema === true || this.analyticalModelData.isStarSchema === true) {
            this.isStarSchema = true;
            this.setType();
            this.setSelectedDimensions();
        }
    }

    separateDimensionAndMeasure() {
        this.analyticalModelData.cube.cubeMeasureData.forEach((measure) => {
            if (measure.recordFormatFieldId) {
                this.cubeMesMap.set(measure.recordFormatFieldId, measure);
            }else{
                this.formualMeasureMap.set(measure.measureId, measure);
            }
        });
        this.analyticalModelData.cube.cubeDimensionUsageData.forEach((cdu) => {
            this.cubeDimMap.set(cdu.recordFormatFieldId, cdu);
            if (cdu.defaultTimeFilter === true) {
                this.defaultTimeFilter = cdu.recordFormatFieldId;
            }
            if (cdu.dimensionData.dimTime === true) {
                this.dimTimeMap.set(cdu.recordFormatFieldId, true);
            }
        });
        this.triggerChanges();
    }

    setType() {
        this.analyticalModelData.fact.recordFormatFieldData.forEach((rff, i) => {
            this.isDimMap.set(i, rff.isDim);
        });
    }

    setSelectedDimensions() {
        let self = this;
        self.setRFFIndexMap();
        self.rffIndexMap.forEach((index, rffId) => {
            if (self.isDimMap.get(index)) {
                let cduData = self.cubeDimMap.get(rffId);
                if (cduData) {
                    self.dimMap.set(rffId, cduData.dimensionId);
                    self.selectDimMap.set(index, rffId);
                }
            }

        });
        self.getPKexists();
        self.dimValidation = self.analyticalModelData.cube.id !== undefined;
        this.dimValidationSender.emit(this.dimValidation);
    }

    setRFFIndexMap() {
        this.analyticalModelData.fact.recordFormatFieldData.forEach((rff, index) => {
            this.rffIndexMap.set(rff.refId, index);
        });
    }

    randomIdGenerator() {
        return Math.floor(100000 + Math.random() * 90);
    }

    onChangeOfType(event, rf, i) {
        let value = event.target.value;
        if (value === 'dimension') {
            this.dimValidation = false;
            this.cubeMesMap.delete(rf.refId);
            this.isDimMap.set(i, true);
            this.removeFromMeasureMap(rf.refId, value);
        } else if (value === 'measure') {
            this.selectDimMap.delete(i);
            this.dimMap.delete(rf.refId);
            this.cubeDimMap.delete(rf.refId);
            this.isDimMap.set(i, false);
            this.setDimValidation();
            this.dimTimeMap.delete(rf.refId);
            this.removeFromDimensionMap(rf.refId, value);
        } else {
            this.dimTimeMap.delete(rf.refId);
            this.selectDimMap.delete(i);
            this.dimMap.delete(rf.refId);
            this.isDimMap.set(i, false);
            this.cubeMesMap.delete(rf.refId);
            this.cubeDimMap.delete(rf.refId);
            this.setDimValidation();
            this.analyticalModelData.fact.recordFormatFieldData.forEach((recordFormatField) => {
                if (recordFormatField.refId === rf.refId) {
                    recordFormatField.isDim = null;
                }
            });
        }
        this.triggerChanges();
    }

    setDimValidation() {
        this.dimValidation = (this.selectDimMap.size === this.cubeDimMap.size);
    }

    onSelectDimension(event, rff, i) {

        let rffId = rff.refId;
        let dimension;
        if (event.target.value !== '') {
            this.dimensionList.forEach((dim) => {
                if (dim.refId === +event.target.value) {
                    dimension = dim;
                }
            });
            (!this.cubeDimMap.has(rffId)) ? this.createCubeDimensionUsage(rffId) : null;
            this.cubeDimMap.get(rffId).dimensionData = dimension;
            this.cubeDimMap.get(rffId).name = dimension.displayName;
            this.cubeDimMap.get(rffId).dimensionId = dimension.refId;
            this.cubeDimMap.get(rffId).dimHierarchyLevelId = null;
            this.cubeDimMap.get(rffId).recordFormatFieldId = rffId;
            this.selectDimMap.set(i, rffId);
            this.dimMap.set(rffId, +event.target.value);
            this.dimTimeMap.set(rffId, true);
            this.setDimValidation();
        }
        this.triggerChanges();
    }

    getPKexists() {
        let self = this;
        this.dimensionList.forEach((dim) => {
            if (dim.isPkExists === true) {
                self.PkExistsMap.set(dim.refId, true);
            }
        });
    }

    selectDefaultDim(isdefaultDim, rffId) {
        this.cubeDimMap.forEach((value) => {
            value.defaultTimeFilter = false;
        });
        this.cubeDimMap.get(rffId).defaultTimeFilter = isdefaultDim;
        this.defaultTimeFilter = rffId;
        this.triggerChanges();
    }

    public removeFromMeasureMap(id, type) {
        this.analyticalModelData.cube.cubeMeasureData.some((element) => {
            if (element.refId === id) {
                element.deleted = true;
                return true;
            }
        });
        this.analyticalModelData.fact.recordFormatFieldData.some((rf) => {
            if (rf.refId === id) {
                rf.isDim = true;
            }
        });
        if (type !== 'none') {
            // if (this.dimensionHistory.has(id)) {
            // this.dimensionHistory.set(id, this.dimensionHistory.get(id))
            // } else {
            this.createCubeDimensionUsage(id);
            // }
        }
    }

    public createCubeDimensionUsage(id) {
        let cubeDimension = new CubeDimension();
        cubeDimension.refId = this.randomIdGenerator();
        let rff = this.analyticalModelData.fact.recordFormatFieldData.filter((element) => {
            return element.refId === id;
        });
        cubeDimension.deleted = false;
        cubeDimension.recordFormatField = rff[0];
        cubeDimension.recordFormatFieldId = rff[0].refId;
        cubeDimension.name = cubeDimension.recordFormatField.fieldName;
        cubeDimension.dimensionData.displayName = cubeDimension.recordFormatField.displayName;
        cubeDimension.dimensionData.name = cubeDimension.recordFormatField.fieldName;
        cubeDimension.dimensionData.refId = this.randomIdGenerator();
        cubeDimension.dimensionId = cubeDimension.dimensionData.refId;
        cubeDimension.dimensionData.dimTime = false;
        cubeDimension.dimensionData.deleted = false;
        cubeDimension.dimensionData.dimHierarchyData[0] = new DimHierarchyData();
        cubeDimension.dimensionData.dimHierarchyData[0].name = cubeDimension.name;
        cubeDimension.dimensionData.dimHierarchyData[0].dimId = cubeDimension.dimensionData.refId;
        cubeDimension.dimensionData.dimHierarchyData[0].refId = this.randomIdGenerator();
        cubeDimension.dimensionData.dimHierarchyData[0].recordFormatFieldId = rff[0].refId;
        cubeDimension.dimensionData.dimHierarchyData[0].recordFormatId = rff[0].recordFormatId;
        cubeDimension.dimensionData.dimHierarchyData[0].deleted = false;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0] = new DimHierarchyLevelData();
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].refId = this.randomIdGenerator();
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].displayName = cubeDimension.dimensionData.displayName;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].dimHierarchyId = cubeDimension.dimensionData.dimHierarchyData[0].id;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].field = cubeDimension.recordFormatField;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].recordFormatFieldId = cubeDimension.recordFormatField.refId;
        cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].deleted = false;
        rff[0].sysCreated = false;
        cubeDimension.dimHierarchyLevelId = cubeDimension.dimensionData.dimHierarchyData[0].dimHierarchyLevelData[0].refId;
        this.cubeDimension = cubeDimension;
        if (!this.cubeDimMap.has(id)) {
            this.cubeDimMap.set(id, Object.assign({}, this.cubeDimension));
        }
        console.log(this.cubeDimMap.get(id));
    }

    public removeFromDimensionMap(id, type) {
        this.analyticalModelData.cube.cubeDimensionUsageData.some((element) => {
            if (element.refId === id) {
                element.deleted = true;
                return true;
            }
        });
        this.analyticalModelData.fact.recordFormatFieldData.some((rf) => {
            if (rf.refId === id) {
                rf.isDim = false;
            }
        });
        if (type !== 'none') {
            this.createCubeMeasureData(id);
        }
    }

    public createCubeMeasureData(id) {
        let cubeMeasureData = new CubeMeasure();
        let rff = this.analyticalModelData.fact.recordFormatFieldData.filter((element) => {
            return element.refId === id;
        });
        cubeMeasureData.recordFormatField = rff[0];
        cubeMeasureData.recordFormatFieldId = cubeMeasureData.recordFormatField.refId;
        cubeMeasureData.name = cubeMeasureData.recordFormatField.fieldName;
        cubeMeasureData.deleted = false;
        cubeMeasureData.measureData = new MeasureData();
        cubeMeasureData.measureData.refId = this.randomIdGenerator();
        cubeMeasureData.measureId = cubeMeasureData.measureData.refId;
        cubeMeasureData.measureData.name = cubeMeasureData.name;
        cubeMeasureData.measureData.targetType = 'max';
        cubeMeasureData.measureData.aggregator = 'sum';
        cubeMeasureData.measureData.measureDisplayName = cubeMeasureData.recordFormatField.displayName;
        cubeMeasureData.measureData.deleted = false;
        cubeMeasureData.measureData.measureStatusIndicator = [];
        cubeMeasureData.measureData.measureTarget = [];
        rff[0].sysCreated = false;
        if (!this.cubeMesMap.has(id)) {
            this.cubeMesMap.set(id, Object.assign({}, cubeMeasureData));
        }
    }

    public triggerChanges() {
        this.dimValidationSender.emit(this.dimValidation);
        this.dimensionListSender.emit(this.cubeDimMap);
        this.measureListSender.emit(this.cubeMesMap);
        this.formulaMeasureEmitter.emit(this.formualMeasureMap);
    }
}



// WEBPACK FOOTER //
// ./src/app/bi/admin/pocdesigner/dataMapper.ts